// read => can view the page or the component
// write => can edit or interact with the page or the component

export const permissions = {
    superAdmin: {
        name: 'superAdmin',
        title: 'Sistem Yöneticisi',
        permissions: [
            {
                name: 'dashboard',
                actions: ['read', 'write']
            },
            {
                name: 'confirmButtonQaTechnician',
                actions: ['read', 'write']
            },
            {
                name: 'confirmButtonQaEngineer',
                actions: ['read', 'write']
            },
        ]
    },
    qaTechnician: {
        name: 'qaTechnician',
        title: 'Kalite Kontrol Sorumlusu',
        permissions: [
            {
                name: 'dashboard',
                actions: ['read', 'write']
            },
            {
                name: 'confirmButtonQaTechnician',
                actions: ['read', 'write']
            },
            {
                name: 'confirmButtonQaEngineer',
                actions: ['readOnly']
            },
        ]
    },
    qaEngineer: {
        name: 'qaEngineer',
        title: 'Kontrol Eden',
        permissions: [
            {
                name: 'dashboard',
                actions: ['read', 'write']
            },
            {
                name: 'confirmButtonQaEngineer',
                actions: ['readOnly']
            },
            {
                name: 'confirmButtonQaTechnician',
                actions: ['read', 'write']
            }
        ]
    },
    visitor: {
        name: 'visitor',
        title: 'Ziyaretci',
        permissions: [
            {
                name: 'dashboard',
                actions: ['readOnly']
            },
            {
                name: 'confirmButtonQaEngineer',
                actions: ['readOnly']
            },
            {
                name: 'confirmButtonQaTechnician',
                actions: ['readOnly']
            }
        ]
    }
}